import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "services/redux/rootReducer";

import createUser from "../actions/access/access.createUser";
import listAllUsers from "../actions/access/access.listAllUsers";
import removeUser from "../actions/access/access.removeUser";
import updateUser from "../actions/access/access.updateUser";

import { searchArrayOfUsers } from "../functions/form";

import GenericEditorPage from "features/shared/screens/genericEditorPage";
import AccessForm from "../components/accessForm";

import ACCESS_MANAGEMENT_TABLE from "../constants/table";
import ACCESS_MODAL_CONFIG from "../constants/modal";
import { initialFields } from "../constants/form";
import { User } from "../types/access";
import { EditorAction } from "features/shared/types/actions.editor";

const AccessManagerPage: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();
    const users = useSelector((state: RootState) => state.access.users);

    const handleAddUser = (fields: User) => {
        dispatch(createUser(fields));
    };

    const handleUpdateUser = (uid: string, user: User) => {
        dispatch(updateUser({ uid, optionalFields: user }));
    };

    const handleRemoveUser = (uids: Array<string>) => {
        uids.forEach((uid) => dispatch(removeUser({ uid })));
    };

    const handleRefreshUserList = () => {
        dispatch(listAllUsers());
    };

    useEffect(() => {
        dispatch(listAllUsers());
        dispatch({
            type: EditorAction.SET_MENU_CONFIG,
            menuConfig: {
                disableImportExport: true,
            },
        });

        return () => {
            dispatch({
                type: EditorAction.SET_MENU_CONFIG,
                menuConfig: {
                    disableImportExport: false,
                },
            });
        };
    }, [dispatch]);

    return (
        <GenericEditorPage
            data={users}
            indexer="uid"
            initialForm={initialFields}
            tableDefinition={ACCESS_MANAGEMENT_TABLE}
            modalConfig={ACCESS_MODAL_CONFIG}
            form={AccessForm}
            onAddCallback={handleAddUser}
            onUpdateCallback={handleUpdateUser}
            onRemoveCallback={handleRemoveUser}
            onRefreshCallback={handleRefreshUserList}
            searchFunction={searchArrayOfUsers}
        />
    );
};

export default AccessManagerPage;
